
import '../css/Skills.css'
import node from '../images/node image.jpg'
import docker from '../images/docker.jpg'
import express from '../images/express1.png'
import mongodb from '../images/mongodb.png'
import javaScript from '../images/javascript.png'
import redis from '../images/redis.png'
import mysql from '../images/mysql.png'
import rabbitmq from '../images/rabbitmq.png'
import prometheus from '../images/prometheus.png'
import grafana from '../images/grafana.png'
import gitlab from '../images/gitlab.png'
import react from '../images/react.png'

const skills = [
    {
        // icon: 'fab fa-docker',
        icon:docker,
        title: "Docker",
        description: 'The Docker toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:node,
        title: "Node.js",
        description: 'The Node.js toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:express,
        title: "Express",
        description: 'The Express toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:javaScript,
        title: "JavaScript",
        description: 'The JavaScript toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:mongodb,
        title: "MongoDB",
        description: 'The MongoDB toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:redis,
        title: "Redis",
        description: 'The Redis toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:mysql,
        title: "MySql",
        description: 'The MySql toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:rabbitmq,
        title: "RabbitMQ",
        description: 'The RabbitMQ toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:prometheus,
        title: "Prometheus",
        description: 'The Prometheus toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:grafana,
        title: "Grafana",
        description: 'The Grafana toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:gitlab,
        title: "GitLab",
        description: 'The GitLab toturial',
        learnMore: 'https://google.com.com'
    },
    {
        icon:react,
        title: "React",
        description: 'The React toturial',
        learnMore: 'https://google.com.com'
    },
]


const Skills = () => {
    return (

        <section className='skills'>
            <h2>Skills</h2>
            <div className='cards'>
                {skills.map((eachCard) => (
                    <div className='eachCard'>
                        {/* <a href='http://dockerhub.com' target="_blank" rel="noopener noreferrer"><i className={eachCard.icon}></i></a> <b /> */}
                        <img src={eachCard.icon} alt='IMG' className='eachlogoImg'/>
                            
                        <h3>{eachCard.title}</h3> <b />
                        <p>{eachCard.description}</p>
                        <button href={eachCard.learnMore}>Learn more</button>
                    </div>
                ))}


            </div>

        </section>
    )
}

export default Skills